export default "__VITE_ASSET__vHJUzsV0__"